import { spModeBreakPoint } from "@/styles/theme";
import { useMediaQuery } from "react-responsive";

export const useIsSpMode = (): boolean => {
  const isSpMode = useMediaQuery({
    query: `(max-width: ${spModeBreakPoint}px)`,
  });

  return isSpMode;
};

export const spMode = `@media (max-width: ${spModeBreakPoint}px)`;
